import gsap, {Power4} from 'gsap';
import isMobile from 'ismobilejs';
import toggleFn from './functions/toggle';
import loginHandle from './login';
import createShareButton from './functions/mobile_share';

import './functions/share';
import customSelect from './functions/select-custom';

window.is_mobile = isMobile().phone || window.innerWidth <= 1080;

window.addEventListener('DOMContentLoaded', () => {
  if (!window.is_mobile) {
    customSelect();
  } else {
    createShareButton();
  }

  summaryArticleHandle();
  loginHandle();
  headerHandle();
  toggleFn();
});

let lastScrollTop = 0;
window.addEventListener('scroll', (e) => {
  const st = window.pageYOffset || document.documentElement.scrollTop;

  if (st > lastScrollTop) {
    // downscroll code
    window.scrollDirection = 'down';
  }
  else {
    // upscroll code
    window.scrollDirection = 'up';
  }

  lastScrollTop = st <= 0 ? 0 : st;
});

const summaryArticleHandle = () => {
  const summary = document.querySelector('.single--summary ul');

  if (summary) {
    const titles = document.querySelectorAll('.article-body h2.wp-block-heading:not(.featured-text--title)');
    [...titles].map((title, index) => {
      const rect = title.getBoundingClientRect();
      const item = document.createElement('LI');
      item.innerText = title.innerText;
      summary.appendChild(item);

      gsap.set(title, {
        scrollMargin: document.querySelector('.main--header').offsetHeight + 20,
      });

      if (index === titles.length - 1) {
        gsap.set(summary.closest('nav.single--summary'), {
          zIndex: 1,
          position: 'relative'
        })
      }
    });

    window.addEventListener('scroll', () => {
      [...titles].map((title, index) => {
        const item = document.querySelectorAll('.single--summary li')[index];
        const rect = title.getBoundingClientRect();

        item.addEventListener('click', () => {
          title.scrollIntoView({
            behavior: 'smooth',
          });
        });

        if (rect.top <= window.innerHeight/2 && rect.top >= 0) {
          if (!item.classList.contains('active')) {
            const active = document.querySelector('.single--summary li.active')
            active?.classList.remove('active');
            item.classList.add('active');
          }
        }
      });
    })
  }
};

const stickyHandle = (header_height) => {
  gsap.to('.stuck-to-header', .3, {
    top: header_height + 32,
  });
};

const headerHandle = () => {
  const header = document.querySelector('.main--header');
  const headerLogo = document.querySelector('.header--logo');
  const headerHeight = headerLogo.scrollHeight;

  if (header) {
    gsap.set(header, {
      top: -(headerHeight)
    })
  }

  //toggle burger

  const toggle_burger = document.querySelectorAll('[data-toggle-menu]');
  const menu = document.querySelector('[data-toggle-menu-element]');

  [...toggle_burger].map(button => {
    button.addEventListener('click', () => {
      menu.classList.toggle('toggled');
    })
  })
};
